/**
 * Guuid generation and storing
 * @module Guuid
 */
import uuidv4 from "uuid/v4";
import Cookies from "js-cookie";
var peerGuidCookie = "net.telestream.webrtc.peerIdentifier";
function savePeerGuid(guid) {
    Cookies.set(peerGuidCookie, guid);
}
export function createPeerGuid() {
    var guid = uuidv4();
    savePeerGuid(guid);
    return guid;
}
export function getPeerGuid() {
    return Cookies.get(peerGuidCookie);
}
export function getSessionGuid() {
    var pathname = window.location.pathname;
    var _a = pathname.match(/\/s\/([^\/|\?]+)/), sessionGuid = _a[1];
    if (!sessionGuid) {
        throw new Error("Could not find session guid in the URL pathname: " + pathname);
    }
    return sessionGuid;
}



//////////////////
// WEBPACK FOOTER
// ./src/guid.ts
// module id = 340
// module chunks = 1